import { Injectable } from "@angular/core";

@Injectable()
export class InstanceService {

    private readonly INSTANCE_DOMAIN_STORAGE_KEY: string = "$instance_domain";
    private readonly INSTANCE_URL_STORAGE_KEY: string = "$instance_url";

    public get url(): string {
        const instanceDomain: string = sessionStorage.getItem(this.INSTANCE_DOMAIN_STORAGE_KEY);
        const instanceUrl: string = sessionStorage.getItem(this.INSTANCE_URL_STORAGE_KEY);
        return instanceDomain ?
            `https://${instanceDomain}/${instanceUrl}` : // https required when launching from http://localhost
            instanceUrl;
    }

    public get fullUrl(): string {
        return `${location.protocol}//${location.host}${this.url}`;
    }
}
